import React, { useEffect } from "react";
import { Button, Card, Flex, Form, Input, Select } from "antd";
import { useAddRestaurantDataMutation } from "./restaruant.service";
import { SendOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { ROLE } from "../../constant";

export default function RestaurantCreatePage() {
  const [form] = Form.useForm();

  const navigate = useNavigate();

  const [addRestaurantData, { isSuccess }] = useAddRestaurantDataMutation();

  const handleFormSubmit = async () => {
    const formData = form.getFieldsValue();
    await addRestaurantData({ ...formData, tenantId: "tenant id" });
  };

  useEffect(() => {
    if (isSuccess) {
      form.resetFields();
      navigate("/restaurant");
    }
  }, [isSuccess]);

  return (
    <Card
      title="Restaurant Create"
      style={{ fontSize: "20px" }}
      bordered={false}
      extra={
        <Button
          type="default"
          style={{ marginRight: 8 }}
          onClick={() => navigate("/restaurant")}
        >
          Discard
        </Button>
      }
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFormSubmit}
        initialValues={{
          email: "",
          password: "",
          owner: "",
          address: {
            street: "",
            city: "",
            country: "",
            pincode: "",
          },
        }}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[
            {
              required: true,
              message: "Please enter an Name",
            },
          ]}
        >
          <Input placeholder="Enter Name" />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            {
              required: true,
              message: "Please enter an Email",
            },
            {
              type: "email",
              message: "Please enter a valid email address!",
            },
          ]}
        >
          <Input placeholder="Enter Restaurant Email" />
        </Form.Item>
        {/* <Form.Item
          label="Tenant ID"
          name="tenant_id"
          rules={[
            {
              required: true,
              message: "Please enter an Tenant ID",
            },
          ]}
        >
          <Input placeholder="Enter Tenant ID" />
        </Form.Item> */}

        {/* Password Input */}
        <Form.Item
          label="Password"
          name="password"
          rules={[
            {
              required: true,
              message: "Please enter a Password",
            },
          ]}
        >
          <Input.Password placeholder="Enter Password" />
        </Form.Item>
        {/* Owner's Name Input */}
        <Form.Item
          label="Owner's Name"
          name="owner"
          rules={[
            {
              required: true,
              message: "Please enter the owner's name",
            },
          ]}
        >
          <Input placeholder="Eg. John Doe" />
        </Form.Item>
        {/* Street Address Input */}
        <Form.Item
          label="Street"
          name={["address", "street"]} // Nested field access
          rules={[
            {
              required: true,
              message: "Please enter the street name",
            },
          ]}
        >
          <Input placeholder="Enter Street" />
        </Form.Item>
        {/* City Input */}
        <Form.Item
          label="City"
          name={["address", "city"]} // Nested field access
          rules={[
            {
              required: true,
              message: "Please enter the city",
            },
          ]}
        >
          <Input placeholder="Enter City" />
        </Form.Item>
        {/* Country Input */}
        <Form.Item
          label="Country"
          name={["address", "country"]} // Nested field access
          rules={[
            {
              required: true,
              message: "Please enter the country",
            },
          ]}
        >
          <Input placeholder="Enter Country" />
        </Form.Item>
        {/* Pincode Input */}
        <Form.Item
          label="Pincode"
          name={["address", "pincode"]} // Nested field access
          rules={[
            {
              required: true,
              message: "Please enter the pincode",
            },
          ]}
        >
          <Input placeholder="Enter Pincode" />
        </Form.Item>
        <Flex justify="center">
          <Button type="primary" htmlType="submit">
            Save {<SendOutlined />}
          </Button>
        </Flex>
      </Form>
    </Card>
  );
}
